import { Box, Button, Paper, TextField, Typography, Grid, Accordion, AccordionSummary, AccordionDetails, List, ListItem, ListItemText, Card, FormControl, FormHelperText } from '@mui/material';
import { useEffect, useState } from 'react';
import { useSnackbar } from 'notistack';
import { useNavigate, useParams } from 'react-router-dom';
import configSiteUrls from '../../../configs/configSiteUrls';

import { useAddAcessoInformacaoRespostaMutation, useGetAcessoInformacaoByLoginMutation, useGetAcessoInformacaoQuery } from '../acessoInformacaoApiSlice';
import { ISacessoInformacao, ISacessoInformacaoList, AcessoInformacaoList, AcessoInformacaoRespostaDTO } from '../types/AcessoInformacao';
import { Iso } from '@mui/icons-material';
import { AcessoInformacaoAnexo } from '../types/AcessoInformacaoAnexo';
import {
  useAddAcessoInformacaoAnexosRespostaMutation,
  useGetAcessoInformacaoAnexosQuery,
  useGetAcessoInformacaoAnexosRespostaQuery,
  useRemoveAcessoInformacaoAnexoExcluidoMutation
} from '../acessoInformacaoAnexoApiSlice';
import { GridExpandMoreIcon } from '@mui/x-data-grid';
import GeralAnexosUpload from '../../licitacao/create/GeralAnexosUpload';
import DownloadAnexoButton from '../../noticia/create/DownloadAnexoButton';
import convertImageToWeb from '../../../../../utils/convertImageToWeb';
import errorFormat from '../../../../../utils/errorFormat';

export const AcessoInformacaoEdit = () => {
  const { enqueueSnackbar } = useSnackbar();
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);

  const [dados, setDados] = useState<AcessoInformacaoList>(ISacessoInformacaoList);
  const [resposta, setResposta] = useState<string>('');

  //verificar se for edicao ele pega o id e faz a consulta
  const id = useParams().id || '';
  const { data, isFetching, error } = useGetAcessoInformacaoQuery(id);
  useEffect(() => {
    if (data) {
      setDados(data as AcessoInformacaoList);
      setResposta((data as AcessoInformacaoList).resposta || '');
    }
  }, [data, error, isFetching]);

  const [createAcessoInformacaoResposta, status] = useAddAcessoInformacaoRespostaMutation();
  const [createAnexosResposta, statusCreateAnexosResposta] = useAddAcessoInformacaoAnexosRespostaMutation();
  const [removeAnexosExcluidos, statusRemoveExcluido] = useRemoveAcessoInformacaoAnexoExcluidoMutation();

  const [acessoInformacaoAnexoParaSalvar, setAcessoInformacaoAnexoParaSalvar] = useState<File[]>([]);
  const [acessoInformacaoAnexoSalvo, setAcessoInformacaoAnexoSalvo] = useState<AcessoInformacaoAnexo[] | null>(null);

  const [acessoInformacaoAnexoParaSalvarResposta, setAcessoInformacaoAnexoParaSalvarResposta] = useState<File[]>([]);
  const [acessoInformacaoAnexoSalvoResposta, setAcessoInformacaoAnexoSalvoResposta] = useState<AcessoInformacaoAnexo[] | null>(null);

  const handleFileAnexoChange = async (files: File[]) => {
    const convertedFiles = await Promise.all(files.map(file => convertImageToWeb(file)));
    setAcessoInformacaoAnexoParaSalvarResposta(prev => [...prev, ...convertedFiles]);
  };
  const handleOnDeleteParaSalvarResposta = (index: number) => {
    setAcessoInformacaoAnexoParaSalvarResposta(prev => prev.filter((_, i) => i !== index));
  };
  const handleExcluirTodosAnexos = () => {
    setAcessoInformacaoAnexoParaSalvarResposta([]);
  };

  function handleOnDeleteSalvo(fileId: string) {
    setAcessoInformacaoAnexoSalvoResposta(prev => {
      if (prev) {
        return prev.map(arq => (arq.id === fileId ? { ...arq, excluido: true } : arq));
      }
      return null; // ou um array vazio se preferir
    });
  }

  const { data: dataAnexo, isLoading: isLoadingAnexo } = useGetAcessoInformacaoAnexosQuery({ idAcessoInformacaoAnexo: dados.id ?? '' }, { skip: !dados.id });
  useEffect(() => {
    if (dataAnexo) {
      setAcessoInformacaoAnexoSalvo(dataAnexo);
    }
  }, [dataAnexo]);

  const { data: dataAnexoResposta, isLoading: isLoadingAnexoResposta } = useGetAcessoInformacaoAnexosRespostaQuery({ idAcessoInformacaoAnexo: dados.id ?? '' }, { skip: !dados.id });
  useEffect(() => {
    if (dataAnexoResposta) {
      setAcessoInformacaoAnexoSalvoResposta(dataAnexoResposta);
    }
  }, [dataAnexoResposta]);

  async function handleSubmit(e: React.FormEvent<HTMLFormElement>) {
    e.preventDefault();
    if (!resposta || resposta.trim() === '') {
      enqueueSnackbar('O campo Resposta é obrigatório.', { variant: 'warning' });
      return;
    }

    const parms: AcessoInformacaoRespostaDTO = {
      id: dados.id || '',
      resposta: resposta.trim()
    };

    setLoading(true);
    const result: any = await createAcessoInformacaoResposta(parms);
    const dataAcessoInformacao = result?.data;
    const idAcessoInformacao = dataAcessoInformacao?.id;

    if (idAcessoInformacao) {
      if (acessoInformacaoAnexoParaSalvarResposta.length) {
        const formData = new FormData();
        acessoInformacaoAnexoParaSalvarResposta.forEach(file => formData.append('imagens', file));
        formData.append('acessoInformacaoID', idAcessoInformacao);
        createAnexosResposta(formData);
      }

      if (acessoInformacaoAnexoSalvoResposta && acessoInformacaoAnexoSalvoResposta?.length) {
        let acessoInformacaoAnexoSalvoExcluido: { idAnexo: string }[];

        acessoInformacaoAnexoSalvoExcluido = acessoInformacaoAnexoSalvoResposta.filter(it => it.excluido === true).map(it => ({ idAnexo: it.id }));

        if (acessoInformacaoAnexoSalvoExcluido.length) {
          const formData = new FormData();
          formData.append('acessoInformacaoID', idAcessoInformacao);
          formData.append('anexosExcluidos', JSON.stringify(acessoInformacaoAnexoSalvoExcluido));
          removeAnexosExcluidos(formData);
        }
      }

      handleExcluirTodosAnexos();
      //navigate(configSiteUrls.SITE_ACESSO_INFORMACAO_T);
    }
    setLoading(false);
  }
  useEffect(() => {
    if (status.isError) {
      enqueueSnackbar('Registro não incluído!', { variant: 'error' });
      const erroReturn: string = errorFormat(status);
      enqueueSnackbar(erroReturn, { variant: 'error' });
    }

    if (status.isSuccess) {
      enqueueSnackbar('Registro incluído!', { variant: 'success' });
      // navigate(-1);
      // setGrupo(ISgrupo);
    }
  }, [status]);

  return (
    <Box sx={{ mt: 4, display: 'flex', justifyContent: 'center' }}>
      <Paper
        sx={{
          width: '100%',
          p: 3,
          mx: 'auto',
          maxWidth: {
            xs: '100%', // celular
            sm: '600px', // tablets
            md: '800px', // telas médias
            lg: '1000px', // telas grandes
            xl: '1200px' // monitores muito grandes
          }
        }}
      >
        {!dados.id ? (
          <>
            <Typography variant="body1" sx={{ mb: 2 }}>
              A solicitação que você está tentando acessar não foi encontrada. Verifique se o link está correto ou entre em contato com o suporte para obter assistência.
            </Typography>
          </>
        ) : (
          <>
            <Typography variant="h6" sx={{ mb: 3, fontWeight: 'bold' }}>
              Dados da Solicitação
            </Typography>

            <Card
              elevation={3}
              sx={{
                p: 3,
                borderRadius: 3,
                bgcolor: '#fafafa',
                mb: 3
              }}
            >
              <Grid container spacing={2}>
                <Grid item xs={12} sm={6}>
                  <Box>
                    <Typography variant="caption" color="text.secondary">
                      Nome
                    </Typography>
                    <Typography variant="body1" fontWeight="500">
                      {dados.nome || 'Não informado'}
                    </Typography>
                  </Box>
                </Grid>

                <Grid item xs={12} sm={6}>
                  <Box>
                    <Typography variant="caption" color="text.secondary">
                      Documento
                    </Typography>
                    <Typography variant="body1" fontWeight="500">
                      {dados.documento || 'Não informado'}
                    </Typography>
                  </Box>
                </Grid>

                <Grid item xs={12} sm={6}>
                  <Box>
                    <Typography variant="caption" color="text.secondary">
                      E-mail
                    </Typography>
                    <Typography variant="body1" fontWeight="500">
                      {dados.email || 'Não informado'}
                    </Typography>
                  </Box>
                </Grid>

                <Grid item xs={12} sm={6}>
                  <Box>
                    <Typography variant="caption" color="text.secondary">
                      Telefone
                    </Typography>
                    <Typography variant="body1" fontWeight="500">
                      {dados.telefone || 'Não informado'}
                    </Typography>
                  </Box>
                </Grid>

                <Grid item xs={12} sm={6}>
                  <Box>
                    <Typography variant="caption" color="text.secondary">
                      Categoria
                    </Typography>
                    <Typography variant="body1" fontWeight="500">
                      {dados.categoria || 'Não informado'}
                    </Typography>
                  </Box>
                </Grid>

                <Grid item xs={12}>
                  <Box>
                    <Typography variant="caption" color="text.secondary">
                      Observação
                    </Typography>
                    <Typography variant="body1" fontWeight="500" sx={{ whiteSpace: 'pre-line' }}>
                      {dados.observacao || 'Não informado'}
                    </Typography>
                  </Box>
                </Grid>
              </Grid>

              {acessoInformacaoAnexoSalvo && acessoInformacaoAnexoSalvo.length > 0 && (
                <Grid container spacing={2}>
                  <Grid item xs={12}>
                    <Box>
                      <Accordion defaultExpanded={false}>
                        <AccordionSummary expandIcon={<GridExpandMoreIcon />} aria-controls="panel2-content" id="panel4-header">
                          <Typography color="secondary" variant="body1" gutterBottom>
                            Anexos
                          </Typography>
                        </AccordionSummary>

                        <AccordionDetails>
                          <Paper>
                            {!isLoadingAnexo && (
                              <>
                                <List dense>
                                  {acessoInformacaoAnexoSalvo.map((file: AcessoInformacaoAnexo) => (
                                    <ListItem key={file.path} disablePadding secondaryAction={<DownloadAnexoButton tipo="ACESSO_INFORMACAO" ida={file.path} fileName={file.nomeOriginal} />}>
                                      <ListItemText
                                        primary={file.nomeOriginal}
                                        primaryTypographyProps={{
                                          variant: 'body2',
                                          color: 'secondary'
                                        }}
                                      />
                                    </ListItem>
                                  ))}
                                </List>
                              </>
                            )}
                          </Paper>
                        </AccordionDetails>
                      </Accordion>
                    </Box>
                  </Grid>
                </Grid>
              )}
            </Card>

            <Typography variant="h6" sx={{ mb: 3, fontWeight: 'bold' }}>
              Dados da Resposta
            </Typography>

            <Card
              elevation={3}
              sx={{
                p: 3,
                borderRadius: 3,
                bgcolor: '#fafafa',
                mb: 3
              }}
            >
              <form onSubmit={handleSubmit} method="POST">
                <Grid container spacing={2}>
                  {/* Observação */}
                  <Grid item xs={12}>
                    <FormControl fullWidth>
                      <TextField
                        required
                        label="Resposta"
                        name="resposta"
                        onChange={e => setResposta(e.target.value)}
                        size="small"
                        multiline
                        rows={4}
                        inputProps={{ maxLength: 5000 }}
                        value={resposta}
                      />
                      <FormHelperText>{resposta?.length}/5000 caracteres</FormHelperText>
                    </FormControl>
                  </Grid>
                </Grid>
                <Grid item xs={12}>
                  <Box>
                    <Accordion defaultExpanded={false}>
                      <AccordionSummary expandIcon={<GridExpandMoreIcon />} aria-controls="panel2-content" id="panel4-header">
                        <Typography color="secondary" variant="body1" gutterBottom>
                          Anexos
                        </Typography>
                      </AccordionSummary>

                      <AccordionDetails>
                        <Paper>
                          <GeralAnexosUpload
                            arquivosSalvos={acessoInformacaoAnexoSalvoResposta ?? null}
                            arquivosParaSalvar={acessoInformacaoAnexoParaSalvarResposta}
                            onFileChange={handleFileAnexoChange}
                            onDeleteParaSalvar={handleOnDeleteParaSalvarResposta}
                            onDeleteAll={handleExcluirTodosAnexos}
                            onDeleteSalvo={handleOnDeleteSalvo}
                            tipo="ACESSO_INFORMACAO"
                          />
                        </Paper>
                      </AccordionDetails>
                    </Accordion>
                  </Box>
                </Grid>
                <Grid item xs={12}>
                  <Button type="submit" sx={{ mt: 3, ml: 2 }} variant="contained" color="secondary">
                    Gravar Resposta
                  </Button>

                  <Button variant="outlined" sx={{ mt: 3, ml: 2 }} onClick={() => navigate(configSiteUrls.SITE_ACESSO_INFORMACAO_LIST)}>
                    Voltar
                  </Button>
                </Grid>
              </form>
            </Card>
          </>
        )}
      </Paper>
    </Box>
  );
};
